<template>
  <div class="map-view">
    <div ref="map" id="map"></div>
    <div
      id="editArea"
      v-if="show_edit_popup && !dialog && !show_estimation"
      class="editArea-container esri-widget--panel"
    >
      <v-card class="mx-auto" tile>
        <v-card-title class="primary--text pt-2 pb-1"
          ><span>New Connection</span><v-spacer></v-spacer>
          <v-icon :disabled="current_step == 0" color="accent" @click="reset"> mdi-restart </v-icon></v-card-title
        >
        <v-divider class="ma-1"></v-divider>
        <v-list dense shaped>
          <v-list-item
            v-for="(item, i) in items"
            :key="i"
            :class="{
              'secondary--text v-item--active v-list-item--active': current_step == i,
              'primary--text': current_step > i,
            }"
            :disabled="current_step != i"
            @click="action($event, item.action, i)"
          >
            <v-list-item-icon>
              <v-icon :color="`${current_step == i ? 'secondary' : current_step > i ? 'success' : 'borderLight'}`">
                {{ current_step > i ? "mdi-check-all" : item.icon }}</v-icon
              >
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="bold" v-text="item.text"> </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <div class="text-center pb-5 pt-1" id="proceed">
          <v-btn :disabled="current_step <= 2" small class="" color="secondary" @click="openDetailsPopup"
            >Proceed to details</v-btn
          >
        </div>
      </v-card>
    </div>
    <v-btn
      v-if="dialog && !show_side_bar"
      color="primary"
      tile
      small
      class="side-bar-expansion-button py-5 px-2"
      @click="show_side_bar = true"
      ><v-icon> mdi-chevron-double-left </v-icon></v-btn
    >
    <v-card v-if="dialog" class="side-bar" :light="!this.$vuetify.theme.dark">
      <v-toolbar v-if="show_side_bar" color="primary" dark class="px-1 text-h6 fixed">
        <v-btn small @click="show_side_bar = false" class="mr-1" icon
          ><v-icon large> mdi-chevron-double-right </v-icon></v-btn
        >
        {{ show_estimation ? "" : "New Connection Details" }}
        <v-spacer />
        <v-btn color="secondary" small @click="reset" class="" outlined
          >Start Again<v-icon class="ml-1" small large> mdi-restart </v-icon></v-btn
        >
        <!-- <v-icon v-if="show_estimation" class="mt-2" @click="reset" large>mdi-restart</v-icon> -->
      </v-toolbar>
      <div class="scrollable">
        <NewConDetails v-if="show_side_bar && !show_estimation" @estimateCost="estimateCost"></NewConDetails>
        <div v-if="show_side_bar && show_estimation" class="pa-4">
          <v-row no-gutters class="mx-4">
            <v-col cols="12" class="primaryOutline--text bold text-h6">
              Connection Summary
              <div>
                <div v-if="new_con_location" class="d-flex text-caption primaryGrey--text">
                  <div><v-icon class="mr-1" color="primary" small>mdi-latitude</v-icon>{{ new_con_location.lat }}</div>
                  <div class="ml-3">
                    <v-icon class="mr-1" color="primary" small>mdi-longitude</v-icon>{{ new_con_location.lng }}
                  </div>
                </div>
              </div>
              <v-divider class="ma-0"></v-divider
            ></v-col>
            <v-col cols="12">
              <v-row no-gutters class="mt-2">
                <v-col
                  cols="6"
                  v-for="(item, index) in details"
                  :key="index"
                  class="mb-3 primaryDark--text text-caption"
                >
                  {{ item.label }}
                  <div class="primary--text text-subtitle-1">
                    {{ con_details[item.id] || "-" }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-divider class="ma-0"></v-divider>
          <v-row no-gutters class="mb-2 pt-0 pb-2">
            <v-col cols="12">
              <v-card flat>
                <v-card-title class="accent--text bold text-h6 py-2"> Results </v-card-title>
                <v-divider class="ma-0"></v-divider>
                <v-card-text class="py-2">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-row no-gutters class="my-2">
                        <v-col
                          cols="6"
                          v-for="(item, index) in results_config"
                          :key="index"
                          class="mb-3 primaryDark--text text-caption"
                        >
                          {{ item.label }}
                          <div class="primary--text text-subtitle-1">
                            {{ results[item.id] || "" }}
                          </div>
                        </v-col>
                      </v-row>
                      <v-row
                        no-gutters
                        class="pa-2 mt-2 mb-3 mx-0 secondary rounded"
                        v-if="results.three_phase_recommended"
                      >
                        <v-col cols="1">
                          <v-icon dark> mdi-information </v-icon>
                        </v-col>
                        <v-col cols="11" class="text-subtitle-2 backgroundWhite--text bold">
                          Based on the estimated demand load, Three-Phase connection is recommended.
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row no-gutters v-if="show_out_of_capacity_warning">
                    <v-col cols="12"> <CapacityAreChart /></v-col>
                  </v-row>
                </v-card-text>
                <div class="text-center pb-5 pt-1">
                  <v-btn :disabled="current_step <= 2" small color="primary" @click="redirectToEstatePlanning"
                    >Proceed to SLD</v-btn
                  >
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { loadModules } from "esri-loader";
import NewConDetails from "../components/NewConDetails";
import CapacityAreChart from "../components/CapacityAreChart";

export default {
  name: "ArcGIS",
  props: {
    coordinates: Object,
    height: String,
    popupattribute: String,
    show_edit_popup: Boolean,
    liveStream: Boolean,
  },
  components: { NewConDetails, CapacityAreChart },
  watch: {
    coordinates: function (newval, oldVal) {
      if (newval && newval != oldVal && !this.liveStream) {
        this.center = newval;
        this.loadView();
      }
    },
  },
  data: function () {
    return {
      arcgis_map_ref: {
        sse: "e7015909ec3b4c88a315f192d0abf0eb",
        vt: "eefb4a6aac92479aa4b2134016cc7250",
      },
      map: null,
      view: null,
      legend: null,
      fullscreen: null,
      center: { lng: -4.203942736600776, lat: 56.83878048063114 },
      graphics_layer: null,
      graphics_layer1: null,
      attributes: "",
      locatorTask: null,
      clickHandler: null,
      current_step: 0,
      show_estimation: false,
      dialog: false,
      con_details: null,
      show_side_bar: true,
      new_con_location: null,
      scalebar: null,
      cable_length: 0,
      point: null,
      poly: null,
      draw: null,
      details: [
        { label: "Number of Properties", id: "properties" },
        { label: "Phase Type", id: "phase_type" },
        { label: "Heating Type", id: "heating_type" },
        { label: "Heat pump input (kW)", id: "heat_pump_input" },
        { label: "Backup Heating", id: "backup_heating" },
        { label: "Electric Cooker", id: "electric_cooker" },
        { label: "Electric Shower", id: "electric_shower" },
        { label: "Other significant load (kW)", id: "other_load" },
        { label: "EV charging points per connection", id: "ev_con" },
        { label: "EV number of chargers", id: "ev_chargers" },
        { label: "EV average load per charger (kW)", id: "ev_avg_load" },
      ],
      results_config: [
        { label: "Total Estimated Demand Load per Customer (kVA)", id: "demand_load_per_customer" },
        { label: "Total Amps per customer (A)", id: "total_amps_per_customer" },
        { label: "Total Estimated Demand Load (kVA)", id: "total_estimated_demand_load" },
        { label: "Approx required cable length", id: "cable_length" },
        { label: "Total Estimated Cost (€)", id: "total_estimated_cost" },
      ],
      results: {
        demand_load_per_customer: "",
        total_amps_per_customer: "",
        three_phase_recommended: false,
        total_estimated_cost: 0,
      },
      items: [
        { text: "Draw site boundary", icon: "mdi-home-plus", action: this.add_polygon },
        { text: "Place site supply point", icon: "mdi-plus", action: this.fetchcoordinates },
        { text: "Add cable route to connect main supply", icon: "mdi-minus", action: this.add_polygon },
      ],
      show_out_of_capacity_warning: false,
    };
  },
  mounted() {
    this.loadMap();
  },
  methods: {
    loadLegend() {
      loadModules(["esri/widgets/Legend", "esri/widgets/Expand", "esri/widgets/Fullscreen"], {
        css: true,
      }).then(([Legend, Expand, Fullscreen]) => {
        //defines the legend feature for the map
        this.legend = new Expand({
          content: new Legend({
            view: this.view,
            style: "classic", // other styles include 'classic'
          }),
          view: this.view,
          expanded: true,
        });
        //defines the fullscreen feature for the map
        this.fullscreen = new Fullscreen({
          view: this.view,
        });
      });
    },
    loadMap() {
      loadModules(["esri/WebMap", "esri/views/MapView", "esri/layers/GraphicsLayer"], {
        css: true,
      }).then(([ArcGISMap, MapView, GraphicsLayer]) => {
        // create map with the given options
        this.map = new ArcGISMap({
          portalItem: {
            id: this.arcgis_map_ref[this.tenant],
          },
        });
        this.graphics_layer = new GraphicsLayer();
        this.graphics_layer1 = new GraphicsLayer();
        this.map.add(this.graphics_layer);
        this.map.add(this.graphics_layer1);
        if (this.coordinates) this.loadView(true);
        else {
          this.view = new MapView({
            container: this.$refs["map"],
            map: this.map,
            center: [this.center.lng, this.center.lat],
            zoom: 6,
          });
          this.loadLegend();
          this.view.ui.add(this.legend, "bottom-left"); //adds a legend on the map
          this.view.ui.add(this.fullscreen, "top-right"); //adds a fullscreen feature for the map
        }
        this.show_edit_popup && this.add_polygon(0);
      });
    },
    updateLocation() {
      // this.view
      //   .when(function () {
      // MapView is now ready for display and can be used. Here we will
      // use goTo to view a particular location at a given zoom level and center
      this.view &&
        this.view.goTo({
          center: [this.center.lng, this.center.lat],
          zoom: 18,
        });
      // })
      // .catch(function (err) {
      //   // A rejected view indicates a fatal error making it unable to display.
      //   // Use the errback function to handle when the view doesn't load properly
      //   console.error("MapView rejected:", err);
      // });
    },
    loadView(use_cordinates) {
      loadModules(["esri/views/MapView", "esri/widgets/ScaleBar"], {
        css: true,
      }).then(([MapView, ScaleBar]) => {
        // assign map to this view
        this.view = new MapView({
          container: this.$refs["map"],
          map: this.map,
          center: use_cordinates ? [this.coordinates.lng, this.coordinates.lat] : [this.center.lng, this.center.lat],
          zoom: 18,
        });
        this.scalebar = new ScaleBar({
          view: this.view,
          unit: "metric",
        });
        this.loadLegend();
        this.view.ui.add(this.legend, "bottom-left");
        this.view.ui.add(this.fullscreen, "bottom-right");
        this.fetchpopupattributes();
      });
    },
    fetchpopupattributes() {
      loadModules(["esri/core/reactiveUtils"], {
        css: true,
      }).then(([reactiveUtils]) => {
        //fetch and displays in console the attributes and title for a selected feature in a popup displayed on the map
        this.view.popup.watch("selectedfeature", function () {
          if (this.view.popup.selectedFeature != null) {
            console.log("Title: " + this.view.popup.selectedFeature.layer.title);
            console.log("Attributes: " + JSON.stringify(this.view.popup.selectedFeature.attributes));
            console.log(this.view.popup);
          }
        });
        //fetch a list of features for a popup displayed on the map and filters the regional information page from popup
        this.view.when(() => {
          reactiveUtils.watch(
            () => this.view.popup.features,
            (featurelist) => {
              if (Array.isArray(featurelist)) {
                var index = featurelist.findIndex(
                  (feature) => feature.attributes.Area_Type == "UK Parliament Constituency"
                );
                if (index != -1) {
                  featurelist.splice(index, 1);
                  this.view.popup.features = [].concat(featurelist);
                }
              }
            }
          );
        });
      });
    },
    fetchcoordinates() {
      let self = this;
      this.current_step = 1;
      document.body.style.cursor = "crosshair";
      this.clickHandler = this.view.on("click", function (event) {
        self.add_point(event.mapPoint);
        event.stopPropagation();
      });
    },
    add_point(map_point) {
      loadModules(["esri/Graphic"], {
        css: true,
      }).then(([Graphic]) => {
        this.point = null;
        if (map_point) {
          this.point = map_point.clone();
          this.point.z = undefined;
          this.point.hasZ = false;
        }
        const simpleMarkerSymbol = {
          type: "simple-marker",
          color: [81, 248, 12], // Green
          outline: {
            color: [255, 255, 255], // White
            width: 0.8,
          },
        };
        const pointGraphic = new Graphic({
          geometry: this.point,
          symbol: simpleMarkerSymbol,
        });
        this.new_con_location = { lat: map_point.latitude, lng: map_point.longitude };
        this.graphics_layer.add(pointGraphic);
        this.current_step++;
        this.current_step == 2 && this.add_polygon(2);
        this.clickHandler.remove();
        this.clickHandler = null;
      });
    },
    add_polygon(step) {
      let self = this;
      this.current_step = step;
      loadModules(["esri/views/draw/Draw"], {
        css: true,
      }).then(([Draw]) => {
        document.body.style.cursor = "crosshair";

        // create a new instance of draw
        this.draw = new Draw({
          view: this.view,
        });

        // create an instance of draw polyline action
        // the polyline vertices will be only added when
        // the pointer is clicked on the view
        var action =
          this.current_step != 0
            ? this.draw.create("polyline", { mode: "click" })
            : this.draw.create("polygon", { mode: "click" });
        action.on("vertex-add", this.redrawPolygon);
        action.on("cursor-update", this.redrawPolygon);
        action.on("draw-complete", function () {
          self.measureLine();
          document.body.style.cursor = "default";
          self.current_step++;
          self.current_step == 1 && self.fetchcoordinates();
        });
      });
    },
    measureLine() {
      loadModules(["esri/geometry/geometryEngine"], {
        css: true,
      }).then(([geometryEngine]) => {
        let lineLength = geometryEngine.geodesicLength(this.poly);
        this.cable_length = lineLength;
      });
    },
    redrawPolygon(evt) {
      loadModules(["esri/geometry/Polygon", "esri/geometry/Polyline", "esri/Graphic"], {
        css: true,
      }).then(([Polygon, Polyline, Graphic]) => {
        this.current_step == 0 ? this.graphics_layer.removeAll() : this.graphics_layer1.removeAll();
        //cursor-update or vertex-add
        // let evt_type = evt.type;
        var polygonSymbol = {
          type: this.current_step == 0 ? "simple-fill" : "simple-line",
          color: this.current_step == 0 ? [255, 0, 0, 0.1] : [69, 64, 58, 0.9],
          width: 2,
          outline: {
            color: [255, 0, 0],
            width: "2.0px",
          },
        };
        var vertices = evt.vertices;

        this.poly =
          this.current_step == 0
            ? new Polygon({
                rings: vertices,
                spatialReference: 102100,
              })
            : new Polyline({
                paths: vertices,
                spatialReference: 102100,
              });

        var graphic = new Graphic({
          geometry: this.poly,
          symbol: polygonSymbol,
        });
        this.current_step == 0 ? this.graphics_layer.add(graphic) : this.graphics_layer1.add(graphic);
      });
    },
    reset() {
      this.draw.destroy();
      this.graphics_layer.removeAll();
      this.graphics_layer1.removeAll();
      // this.measurement.clear();
      this.dialog = false;
      this.show_estimation = false;
      this.current_step = 0;
      this.show_edit_popup && this.add_polygon(0);
      this.clickHandler && this.clickHandler.remove();
      this.clickHandler = null;
    },
    openDetailsPopup() {
      this.dialog = true;
    },
    action(event, callback, step) {
      this.current_step = step;
      callback(step);
    },
    estimateCost(event) {
      this.con_details = event;
      const DIVERSITY_FACTOR = 0.4;
      const POWER_FACTOR = 0.7;
      const SUPPLY_VOLTAGE = 230;
      const AVG_EV_LOAD = 8;
      const TRANSFORMER_RATING = 1000;
      const MAX_LOAD = 799.9;
      let cable_length = this.cable_length || 50;
      let hetaing_load =
        event.heating_type != "Gas" ? (event.heat_pump_input ? parseInt(event.heat_pump_input) : 8) : 0; //If Heating Type, "Gas"-0, "Electric Resistance"-8, "Heat Pump"- Default 8
      let backup_heating_load = event.backup_heating == "Electric" ? 3 : 0; //If Backup Heating, "Electric"-4, "None"-0
      let electric_cooker_load = event.electric_cooker == "Yes" ? 3 : 0; //If Electric Cooker, "Yes"-6.5, "No"-0
      let electric_shower_load = event.electric_shower == "Yes" ? 7 : 0; //If Electric Shower, "Yes"-8.5, "No"-0
      let other_load = event.other_load ? parseInt(event.other_load) : 0; //If other load entered by user else 0
      let ev_load =
        event.ev_con == "Yes"
          ? event.ev_chargers && event.ev_avg_load
            ? event.ev_chargers * event.ev_avg_load
            : event.ev_chargers * AVG_EV_LOAD
          : 0; //If EV connection,  "Yes"- No. of chargers * load per charger else 0
      this.show_estimation = true;
      let load_demand =
        hetaing_load + backup_heating_load + electric_cooker_load + electric_shower_load + other_load + ev_load; //Sum of base laod and load based on user selection

      let multiplication_factor_phase_type = event.phase_type == "Single" ? 1 : 3;

      //Calculations
      let total_demand_per_customer = load_demand * DIVERSITY_FACTOR; //kW
      let apparent_power_per_customer = total_demand_per_customer / POWER_FACTOR; // kVA
      let total_amps_per_customer =
        (1000 * apparent_power_per_customer) / (multiplication_factor_phase_type * SUPPLY_VOLTAGE); //Amps
      let total_estimated_demand_load = event.properties * apparent_power_per_customer; // kVA
      let three_phase_recommended = event.phase_type == "Single" && total_amps_per_customer > 63; //Amps
      let total_estimated_cost = total_amps_per_customer > 63 ? 5000 + cable_length * 120 : 3500 + cable_length * 40; //€

      // Update results object
      this.results = {
        demand_load_per_customer: apparent_power_per_customer.toFixed(2) + " kVA",
        total_amps_per_customer: total_amps_per_customer.toFixed(2) + " A",
        total_estimated_demand_load: total_estimated_demand_load.toFixed(2) + " kVA",
        three_phase_recommended: three_phase_recommended,
        total_estimated_cost: total_estimated_cost.toFixed(2) + " €",
        cable_length: this.cable_length.toFixed(2) + " m",
      };
      this.show_out_of_capacity_warning = total_estimated_demand_load + MAX_LOAD > TRANSFORMER_RATING;
    },
    redirectToEstatePlanning() {
      this.$router.push({ name: "EstatePlanning" });
    },
  },
  computed: {
    tenant: function () {
      let tenant = this.$store.state.tenant_config.customer_name;
      return tenant ? tenant : null;
    },
  },
};
</script>
<style lang="scss" scoped>
@import url("https://js.arcgis.com/4.4/esri/themes/light/main.css");
.map-view {
  position: relative;
  padding: 0;
  margin: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
}
#map {
  height: 100%;
  width: 100%;
}
#formDiv {
  width: 100%;
}

.esri-item-list__scroller {
  overflow-y: visible;
}

.editArea-container {
  border: 1px solid var(--v-border-base);
  top: 1rem;
  right: 1rem;
  z-index: 9;
  position: absolute;
  background: #fff;
  line-height: 1.5em;
  overflow: auto;
  width: 325px;
}

.list-heading {
  font-weight: normal;
  margin-top: 20px;
  margin-bottom: 10px;
  color: #323232;
}

.or-wrap {
  background-color: #e0e0e0;
  height: 1px;
  margin: 2em 0;
  overflow: visible;
}

.or-text {
  background: #fff;
  line-height: 0;
  padding: 0 1em;
  position: relative;
  bottom: 0.75em;
}

/* override default styles */
.esri-feature-form {
  background: #fff;
}

.esri-feature-templates {
  width: 256px;
}

.esri-feature-templates__section-header {
  display: none;
}

.esri-feature-templates__section {
  box-shadow: none;
}

.esri-feature-templates__scroller {
  max-height: 200px;
}
.side-bar {
  z-index: 9;
  top: 0;
  right: 0;
  position: fixed;
  max-width: 32vw;
  height: 100vh;
  overflow: auto;
  .fixed {
    position: fixed;
    width: 32vw;
    z-index: 99;
  }
  .scrollable {
    position: relative;
    top: 4rem;
    overflow: auto;
  }
}
.side-bar-expansion-button {
  z-index: 9;
  position: fixed;
  top: 70px;
  right: 0;
}
.results-con {
  border-radius: 2%;
  border: 3px dotted var(--v-accent-base);
}
</style>
